/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { ContentZoneContext } from "cms/components/context";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InfoBoxComponentDisplay = () => {

    const ctx = useContext(ContentZoneContext);
    const component = ctx.component;
    const { richtext } = component || {};
    const hasContent = !isRichTextEmpty(component.richtext);

    return (
        <>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <>
                    <div className='simplicity-info-box'>
                        <div className='simplicity-info-box-icon'>
                            <span className='fa-layers fa-fw fa-lg'>
                                <FontAwesomeIcon
                                    icon={"fa-solid fa-message"}
                                    transform={"grow-4"}
                                />
                                <FontAwesomeIcon
                                    icon={"fa-solid fa-info"}
                                    transform={"shrink-6 up-3"}
                                    className={"font-awesome-icon-layer"}
                                />
                            </span>
                        </div>
                        <div className='simplicity-info-box-content'>
                            <RichTextPreview richtext={richtext}/>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

InfoBoxComponentDisplay.displayName = "InfoBoxComponentDisplay";
export { InfoBoxComponentDisplay };
